import { ReimbursementType } from '@nkr/enums/index';
import { IWatrRequest } from '@nkr/models/index';

const hasServerArVisitCaps = (request: IWatrRequest): boolean =>
    request.arWorkupVisitCap != null
    || request.arPreOpVisitCap != null
    || request.arInternationalWorkupVisitCap != null;

export const getArReimbursementVisitCap = (
    type: number,
    request?: IWatrRequest | null
): number | null => {
    if (!request) {
        return null;
    }

    if (type === ReimbursementType.InternationalWorkup) {
        return request.arInternationalWorkupVisitCap ?? null;
    }

    if (type === ReimbursementType.AdvancedReimbursement) {
        return request.arWorkupVisitCap ?? null;
    }

    if (type === ReimbursementType.AdvancedReimbursementPreOp) {
        return request.arPreOpVisitCap ?? null;
    }

    return null;
};

export const isIntlArPreOpDisallowed = (
    type: number,
    request?: IWatrRequest | null
): boolean => {
    if (type !== ReimbursementType.AdvancedReimbursementPreOp || request == null) {
        return false;
    }

    return hasServerArVisitCaps(request) && request.arPreOpVisitCap == null;
};

export const getArReimbursementVisitLabel = (type: number): string => {
    if (type === ReimbursementType.AdvancedReimbursementPreOp) {
        return 'Pre-Op';
    }

    if (type === ReimbursementType.InternationalWorkup) {
        return 'International Workup';
    }

    return 'Work-Up';
};
